export default {
  'pages.covenantDevice.mac': 'MAC地址',
  'pages.admin.providerCard.config.grpcAddr': 'gRPC地址',
  'pages.covenantDevice.cardTitle': '协约设备管理',
  'pages.unbindDevice.cardTitle': '设备解绑',
  'pages.whiteList.cardTitle': '白名单管理',
  'pages.admin.whitelist.mac': 'MAC地址',
  'pages.covenantDevice.operations': '操作',
  'pages.covenantDevice.expireTime': '到期时间',
  'pages.covenantDevice.updateTime': '更新时间',

  'pages.admin.ops.logViewer.previewTitle': '日志预览',
  'pages.admin.ops.logViewer.fileName': '文件名：',
  'pages.admin.ops.logViewer.lineCount': '行数：',
  'pages.admin.ops.logViewer.previewBtn': '预览',
  'pages.admin.ops.logViewer.noContent': '暂无内容',

  'pages.admin.devices': '设备管理',
  'pages.admin.unbindDevice': '设备解绑',
  'pages.admin.deviceManage': '设备管理',
  'pages.unbindDevice.titleAdmin': '设备解绑（需管理员权限）',
  'pages.unbindDevice.inputPlaceholder': '请输入设备ID',
  'pages.unbindDevice.unbind': '解绑',
  'pages.unbindDevice.unbinding': '解绑中...',
  'pages.unbindDevice.success': '解绑成功',
  'pages.unbindDevice.fail': '解绑失败',
  'pages.layouts.userLayout.title': '管理控制台',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码',
  'pages.register': '新用户注册',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  // Agents 页面相关文本
  'pages.agents.search.placeholder': '搜索智能体',
  'pages.agents.create.button': '新建智能体',
  'pages.agents.addDevice.button': '添加设备',
  'pages.agents.create.modal.title': '新建智能体',
  'pages.agents.create.modal.nameLabel': '智能体名称',
  'pages.agents.create.modal.placeholder': '请输入智能体名称',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': '角色音色',
  'pages.agents.card.languageModel': '语言模型',
  'pages.agents.card.lastChat': '最近对话',
  'pages.agents.card.conversationId': '会话ID',
  'pages.agents.card.clearConversation': '清除会话ID',
  'pages.agents.card.clearConversation.success': '会话ID已清除',
  'pages.agents.card.clearConversation.error': '清除会话ID失败',
  'pages.agents.card.configRole': '配置角色',
  'pages.agents.card.voiceRecognition': '声纹识别',
  'pages.agents.card.voiceRecognition.developing': '功能开发中，敬请期待',
  'pages.agents.card.historyDialog': '历史对话',
  'pages.agents.card.manageDevice': '管理设备',
  'pages.agents.card.addDevice': '添加设备',
  'pages.agents.loading': '加载智能体列表中...',
  'pages.agents.reload': '重新加载',
  'pages.agents.empty.title': '暂无智能体',
  'pages.agents.empty.createFirst': '创建第一个智能体',
  'pages.agents.delete.title': '确定删除智能体',
  'pages.agents.delete.content': '删除智能体后，该智能体有关配置（包括设备相关的对话记录）将无法恢复。确定删除吗？',
  'pages.agents.delete.confirm': '确认删除',
  'pages.agents.fetch.error': '获取智能体列表失败',
  'pages.agents.network.error': '网络错误，请稍后重试',
  'pages.agents.speed.patient': '耐心',
  'pages.agents.speed.normal': '正常',
  'pages.agents.speed.fast': '快速',
  'pages.agents.lastChat.none': '无',
  'pages.agents.language.chinese': '中文',
  'pages.agents.loading.tts.error': '加载TTS音色失败',
  'pages.agents.loading.llm.error': '加载LLM提供者失败',
  'pages.agents.sort.id': '按ID排序',
  'pages.agents.sort.updatedAt': '按最近修改',
  'pages.agents.sort.lastConversationAt': '按最近对话',

  // Register 页面相关文本
  'pages.register.title': '注册',
  'pages.register.form.title': '注册新账户',
  'pages.register.submit': '注册',
  'pages.register.username.placeholder': '请输入用户名',
  'pages.register.username.required': '请输入用户名！',
  'pages.register.username.min': '用户名至少4个字符',
  'pages.register.email.placeholder': '请输入邮箱',
  'pages.register.email.required': '请输入邮箱！',
  'pages.register.email.invalid': '请输入有效的邮箱地址！',
  'pages.register.password.placeholder': '请输入密码',
  'pages.register.password.required': '请输入密码！',
  'pages.register.password.min': '密码至少6个字符',
  'pages.register.password.pattern': '密码必须包含大小写字母和数字',
  'pages.register.confirmPassword.placeholder': '请确认密码',
  'pages.register.confirmPassword.required': '请确认密码！',
  'pages.register.confirmPassword.min': '密码至少6个字符',
  'pages.register.error.passwordMismatch': '两次输入的密码不一致',
  'pages.register.error.registerFailed': '注册失败，请重试！',
  'pages.register.success': '注册成功！',

  // Login 页面相关文本
  'pages.login.title': 'Anime AI Chat 管理控制台',
  'pages.login.actionIcons.notImplemented': '暂未实现，敬请期待',
  'pages.login.mobile.captchaError': '验证码错误',
  'pages.login.captcha.success': '获取验证码成功！验证码为：1234',
  'pages.login.forgotPassword.contactAdmin': '请联系管理员',
  'pages.login.mobile.notAvailable': '此功能暂未开放，请使用账户密码登录',

  // SystemConfig 页面相关文本
  'pages.systemConfig.quickReply': '快速回复',
  'pages.systemConfig.useShortTermMemory': '短期记忆',
  'pages.systemConfig.useShortTermMemory.desc': '开启后，系统使用短期记忆机制，每轮对话后更新短期记忆。关闭则不使用短期记忆。',

  // AgentSetting 页面相关文本
  'pages.agentSetting.title': '配置角色',
  'pages.agentSetting.back': '返回',
  'pages.agentSetting.roleTemplate.title': '角色模板',
  'pages.agentSetting.roleTemplate.label': '模板',
  'pages.agentSetting.template.taiwanGirlfriend': '台湾女友',
  'pages.agentSetting.template.potato': '土豆子',
  'pages.agentSetting.template.englishTutor': 'English Tutor',
  'pages.agentSetting.template.curiousBoy': '好奇小男孩',
  'pages.agentSetting.template.puppyLeader': '汪汪队长',
  'pages.agentSetting.basicConfig.title': '基础配置',
  'pages.agentSetting.assistantName.label': '助手昵称',
  'pages.agentSetting.assistantName.placeholder': '请输入助手昵称',
  'pages.agentSetting.assistantName.required': '请输入助手昵称',
  'pages.agentSetting.dialogLanguage.label': '对话语言',
  'pages.agentSetting.dialogLanguage.placeholder': '选择对话语言',
  'pages.agentSetting.voiceType.label': '角色音色',
  'pages.agentSetting.voiceType.placeholder': '选择角色音色',
  'pages.agentSetting.roleDescription.title': '角色介绍',
  'pages.agentSetting.roleDescription.label': '角色介绍',
  'pages.agentSetting.roleDescription.placeholder': '请输入角色介绍',
  'pages.agentSetting.roleDescription.required': '请输入角色介绍',
  'pages.agentSetting.languageModel.title': '语言模型',
  'pages.agentSetting.languageModel.label': '语言模型',
  'pages.agentSetting.languageModel.placeholder': '选择语言模型',
  'pages.agentSetting.languageModel.tip': '改变模型后，建议清空记忆体，以免影响聊天体验。',
  'pages.agentSetting.advancedSettings.expand': '展开高级设置',
  'pages.agentSetting.advancedSettings.collapse': '收起高级设置',
  'pages.agentSetting.recognitionSpeed.label': '语音识别速度',
  'pages.agentSetting.recognitionSpeed.placeholder': '选择识别速度',
  'pages.agentSetting.speechSpeed.label': '角色语速',
  'pages.agentSetting.speechSpeed.placeholder': '选择语速',
  'pages.agentSetting.pitchValue.label': '角色音量',
  'pages.agentSetting.button.reset': '重置',
  'pages.agentSetting.button.save': '保存',
  'pages.agentSetting.save.success': '保存成功',
  'pages.agentSetting.save.error': '保存失败',
  'pages.agentSetting.save.missingId': '缺少 agent id，无法保存',
  'pages.agentSetting.load.tts.error': '加载TTS音色失败',
  'pages.agentSetting.speed.slow': '慢速',
  'pages.agentSetting.speed.normal': '正常',
  'pages.agentSetting.speed.fast': '快速',
  'pages.agentSetting.speed.patient': '耐心',
  'pages.agentSetting.language.chinese': '普通话',
  'pages.agentSetting.language.english': '英语',
  'pages.agentSetting.language.spanish': '西班牙语',
  'pages.agentSetting.language.french': '法语',
  'pages.agentSetting.language.german': '德语',
  'pages.agentSetting.language.japanese': '日语',
  'pages.agentSetting.language.korean': '韩语',
  'pages.agentSetting.language.portuguese': '葡萄牙语',
  'pages.agentSetting.language.arabic': '阿拉伯语',
  'pages.agentSetting.language.russian': '俄语',
  'pages.agentSetting.language.italian': '意大利语',
  'pages.agentSetting.language.turkish': '土耳其语',
  'pages.agentSetting.language.polish': '波兰语',
  'pages.agentSetting.language.catalan': '加泰罗尼亚语',
  'pages.agentSetting.mcp.modal.title': 'MCP接入点',
  'pages.agentSetting.mcp.modal.statusLabel': '接入点状态',
  'pages.agentSetting.mcp.modal.online': '在线',
  'pages.agentSetting.mcp.modal.disconnected': '未连接',
  'pages.agentSetting.mcp.modal.unknown': '未连接',
  'pages.agentSetting.mcp.modal.refresh': '刷新',
  'pages.agentSetting.mcp.modal.enabledServices': '启用的服务',
  'pages.agentSetting.mcp.modal.endpointLabel': '接入点地址',
  'pages.agentSetting.mcp.modal.endpointDesc': '以下是智能体的MCP接入点地址。',
  'pages.agentSetting.mcp.modal.docLink': '查看接入点使用文档',
  'pages.agentSetting.mcp.modal.noEndpoint': '无可用接入点',
  'pages.agentSetting.mcp.modal.hide': '隐藏',
  'pages.agentSetting.mcp.modal.show': '显示',
  'pages.agentSetting.mcp.modal.copied': '已复制',
  'pages.agentSetting.mcp.modal.copy': '复制',
  'pages.agentSetting.mcp.title': 'MCP设置',
  'pages.agentSetting.mcp.officialServices': '官方服务',
  'pages.agentSetting.mcp.officialServices.placeholder': '选择官方服务',
  'pages.agentSetting.mcp.services.weather': '天气',
  'pages.agentSetting.mcp.services.joke': '笑话',
  'pages.agentSetting.mcp.services.music': '音乐',
  'pages.agentSetting.mcp.services.news': '新闻',
  'pages.agentSetting.mcp.customService': '自定义服务',
  'pages.agentSetting.mcp.error.missingId': '缺少 agent id，无法获取接入点',
  'pages.agentSetting.mcp.error.noEndpoint': '无法从服务端获取接入点',
'pages.agentSetting.mcp.error.fetchFailed': '获取接入点失败',
  'pages.agentSetting.mcp.button.getEndpoint': '获取 MCP 接入点',

  // Memory settings
  'pages.agentSetting.memory.title': '短期记忆',
  'pages.agentSetting.memory.type.label': '记忆类型',
  'pages.agentSetting.memory.type.none': '无记忆',
  'pages.agentSetting.memory.type.shortTerm': '短期记忆',
  'pages.agentSetting.memory.current.label.short': '当前记忆',
  'pages.agentSetting.memory.current.help': '每次对话后重新生成',
  'pages.agentSetting.memory.clear': '清除记忆',
  'pages.agentSetting.memory.clear.tip': '记忆已标记为清除，请点击保存以应用生效',
  'pages.agentSetting.memory.content.label': '记忆内容',
  'pages.agentSetting.memory.content.placeholder': '获取当前智能体最新短期记忆内容',
  'pages.agentSetting.memory.content.editPlaceholder': '请输入记忆内容',
  'pages.agentSetting.memory.edit': '编辑记忆',
  'pages.agentSetting.memory.edit.success': '记忆已更新，请在保存后生效',
  'pages.agentSetting.memory.edit.save': '保存修改',
  'pages.agentSetting.memory.edit.cancel': '取消',

  // DeviceManagement 页面相关文本
  'pages.devices.title': '管理设备',
  'pages.devices.breadcrumb.agents': '智能体',
  'pages.devices.breadcrumb.devices': '管理设备',
  'pages.devices.button.addDevice': '添加设备',
  'pages.devices.warning.noAgentId': '未指定 agentId，无法获取设备列表',
  'pages.devices.device.unnamed': '未命名设备',
  'pages.devices.device.macAddress': 'Mac地址',
  'pages.devices.device.lastActive': '最近对话',
  'pages.devices.device.firmwareVersion': '固件版本',
  'pages.devices.device.otaUpgrade': 'OTA升级',
  'pages.devices.device.noData': '暂无',
  'pages.devices.copy.success': 'MAC地址已复制',
  'pages.devices.unbind.title': '确认解绑设备',
  'pages.devices.unbind.content': '设备解绑后不可恢复，如需再次使用需重新绑定。是否确认解绑？',
  'pages.devices.unbind.confirm': '确认解绑',
  'pages.devices.unbind.cancel': '取消',
  'pages.devices.unbind.success': '设备已解绑',
  'pages.devices.unbind.error': '解绑失败',
  'pages.devices.ota.enabled': 'OTA升级已开启',
  'pages.devices.ota.disabled': 'OTA升级已关闭',

  // HistoryDialogs 页面相关文本
  'pages.historyDialogs.title': '历史对话',
  'pages.historyDialogs.breadcrumb.agents': '智能体',
  'pages.historyDialogs.breadcrumb.historyDialogs': '历史对话',
  'pages.historyDialogs.empty.title': '没有选中对话',
  'pages.historyDialogs.empty.description': '请选择一个对话',
  'pages.historyDialogs.agent': 'Agent',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': '对话详情',
  'pages.historyDialogs.selectConversation': '请选择一个对话',
  'pages.historyDialogs.delete.title': '删除对话',
  'pages.historyDialogs.delete.content': '删除后无法恢复，请确认操作。',
  'pages.historyDialogs.delete.confirm': '确认删除',
  'pages.historyDialogs.delete.cancel': '取消',
  'pages.historyDialogs.message.delete.confirm': '确定要删除该消息吗？删除后不可恢复。',
  'pages.historyDialogs.detail.title': '对话详情',

  'pages.historyDialogs.agent.label': '智能体:',
  'pages.historyDialogs.user.label': '用户:',
  'pages.historyDialogs.loading': '加载中...',
  'pages.historyDialogs.error.loadFailed': '加载对话列表失败',
  'pages.historyDialogs.error.deleteFailed': '删除会话失败',
  'pages.historyDialogs.success.deleteSuccess': '成功删除对话',

  // MessageList 页面相关文本
  'pages.messageList.empty': '暂无消息',
  'pages.messageList.user': 'User',
  'pages.messageList.ai': 'AI',

  // Settings 页面相关文本
  'pages.settings.basicInfo.title': '基本信息',
  'pages.settings.avatar.label': '头像：',
  'pages.settings.avatar.change': '更换头像',
  'pages.settings.avatar.updateSuccess': '头像已更新',
  'pages.settings.avatar.updateFailed': '头像更新失败',
  'pages.settings.registerTime.label': '注册时间：',
  'pages.settings.email.label': '邮箱：',
  'pages.settings.email.unbind': '未绑定',
  'pages.settings.email.bind': '绑定邮箱',
  'pages.settings.email.change': '修改绑定邮箱',
  'pages.settings.email.modal.title': '绑定邮箱',
  'pages.settings.email.modal.changeTitle': '修改绑定邮箱',
  'pages.settings.email.form.label': '邮箱',
  'pages.settings.email.form.required': '请输入邮箱',
  'pages.settings.email.form.invalid': '邮箱格式不正确',
  'pages.settings.email.bindSuccess': '邮箱绑定成功',
  'pages.settings.email.bindFailed': '绑定失败',
  'pages.settings.changePassword.title': '修改密码',
  'pages.settings.changePassword.button': '修改密码',
  'pages.settings.changePassword.modal.title': '修改密码',
  'pages.settings.changePassword.oldPassword.label': '旧密码',
  'pages.settings.changePassword.oldPassword.required': '请输入旧密码',
  'pages.settings.changePassword.newPassword.label': '新密码',
  'pages.settings.changePassword.newPassword.required': '请输入新密码',
  'pages.settings.changePassword.newPassword.min': '新密码长度至少6位',
  'pages.settings.changePassword.confirmPassword.label': '确认新密码',
  'pages.settings.changePassword.confirmPassword.required': '请确认新密码',
  'pages.settings.changePassword.confirmPassword.mismatch': '两次输入的密码不一致',
  'pages.settings.changePassword.success': '密码修改成功',
  'pages.settings.changePassword.failed': '密码修改失败',
  'pages.settings.deleteAccount.title': '删除账号',
  'pages.settings.deleteAccount.button': '删除账号',
  'pages.settings.deleteAccount.confirm.title': '确认删除账号？',
  'pages.settings.deleteAccount.confirm.content': '此操作不可恢复，确定要删除账号吗？',
  'pages.settings.deleteAccount.confirm.ok': '删除',
  'pages.settings.deleteAccount.confirm.cancel': '取消',
  'pages.settings.deleteAccount.success': '账号已删除',
  'pages.settings.deleteAccount.failed': '删除失败',
  'pages.settings.profile.fetchFailed': '获取用户信息失败',
  'pages.settings.form.submit': '提交',
  'pages.settings.password.title': '密码设置',
  'pages.settings.basicInfo.username': '用户名',
  'pages.settings.basicInfo.nickname': '昵称',
  'pages.settings.basicInfo.avatar': '头像',
  'pages.settings.basicInfo.editNickname': '编辑昵称',
  'pages.settings.basicInfo.editNicknameTitle': '修改昵称',
  'pages.settings.basicInfo.newNicknameLabel': '新昵称',
  'pages.settings.basicInfo.nicknameChangeSuccess': '昵称修改成功',
  'pages.settings.basicInfo.openId': 'OpenID：',
  'pages.settings.submit': '保存',
  'pages.settings.deleteAccount.confirmTitle': '删除账号确认',
  'pages.settings.deleteAccount.confirmContent': '删除账号后，您的所有数据将被永久删除且无法恢复，且您将无法再次使用该账号登录。请谨慎操作！',
  'pages.settings.deleteAccount.cancel': '取消',
  'pages.settings.deleteAccount.confirm': '确认删除',

  // Admin Dashboard
  'pages.admin.dashboard.userCount': '用户数量',
  'pages.admin.dashboard.deviceCount': '设备数量',
  'pages.admin.dashboard.agentCount': '智能体数量',
  'pages.admin.dashboard.onlineUsers': '在线用户数',
  'pages.admin.dashboard.sessionDevices': '对话用户数',
  'pages.admin.dashboard.memoryUsage': '内存使用率',
  'pages.admin.dashboard.cpuUsage': 'CPU使用率',
  'pages.admin.dashboard.fetchError': '获取数据失败',
  'pages.admin.dashboard.networkError': '网络错误',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': '用户名',
  'pages.admin.user.email': '邮箱',
  'pages.admin.user.status': '状态',
  'pages.admin.user.status.all': '所有',
  'pages.admin.user.status.disabled': '禁用',
  'pages.admin.user.status.normal': '正常',
  'pages.admin.user.quotaUsed': '每日已使用额度',
  'pages.admin.user.quotaTotal': '每日总额度',
  'pages.admin.user.createdAt': '创建时间',
  'pages.admin.user.operations': '操作',
  'pages.admin.user.edit': '编辑',
  'pages.admin.user.detail': '详情',
  'pages.admin.user.editModal.title': '编辑用户',
  'pages.admin.user.status.label': '用户状态',
  'pages.admin.user.status.enable': '启用',
  'pages.admin.user.status.disable': '禁用',
  'pages.admin.user.quotaUsed.label': '今日已使用额度',
  'pages.admin.user.quotaTotal.label': '每日总额度',
  'pages.admin.user.email.label': '邮箱',
  'pages.admin.user.save.success': '保存成功',
  'pages.admin.user.save.failed': '保存失败',
  'pages.admin.user.list.title': '用户列表',

  // Admin Model Providers
  'pages.admin.providers.title': '模型供应商管理',
  'pages.admin.providers.total': '共 {total} 个供应商',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.addNew': '添加新供应商',
  'pages.admin.providers.search.placeholder': '搜索供应商名称、端点或模型...',
  'pages.admin.providers.filter.all': '所有类型',
  'pages.admin.providers.filter.asr': 'ASR - 语音识别',
  'pages.admin.providers.filter.tts': 'TTS - 语音合成',
  'pages.admin.providers.filter.llm': 'LLM - 大语言模型',
  'pages.admin.providers.filter.vlllm': 'VLLLM - 视觉语言模型',
  'pages.admin.providers.empty.noProviders': '还没有任何供应商',
  'pages.admin.providers.empty.noMatches': '没有找到匹配的供应商',
  'pages.admin.providers.empty.addFirst': '点击上方按钮添加您的第一个模型供应商',
  'pages.admin.providers.empty.adjustFilters': '尝试调整搜索条件或筛选器',
  'pages.admin.providers.type.asr': 'ASR - 语音识别',
  'pages.admin.providers.type.tts': 'TTS - 语音合成',
  'pages.admin.providers.type.llm': 'LLM - 大语言模型',
  'pages.admin.providers.type.vlllm': 'VLLLM - 视觉语言模型',
  'pages.admin.providers.success.created': '供应商添加成功！',
  'pages.admin.providers.success.updated': '供应商更新成功！',
  'pages.admin.providers.success.deleted': '供应商删除成功！',
  'pages.admin.providers.success.statusToggled': '状态切换成功！',
  'pages.admin.providers.error.createFailed': '添加供应商失败，请重试',
  'pages.admin.providers.error.updateFailed': '更新供应商失败，请重试',
  'pages.admin.providers.error.deleteFailed': '删除供应商失败，请重试',
  'pages.admin.providers.error.testFailed': '测试连接失败，请检查网络或配置',
  'pages.admin.providers.error.toggleFailed': '切换状态失败，请重试',
  'pages.admin.providers.error.loadFailed': '加载供应商列表失败，请刷新页面重试',

  // Admin Settings
  'pages.admin.settings.title': '系统设置',
  'pages.admin.settings.asr.label': 'ASR 服务',
  'pages.admin.settings.asr.placeholder': '选择 ASR 服务',
  'pages.admin.settings.tts.label': 'TTS 服务',
  'pages.admin.settings.tts.placeholder': '选择 TTS 服务',
  'pages.admin.settings.llm.label': 'LLM 服务',
  'pages.admin.settings.llm.placeholder': '选择 LLM 服务',
  'pages.admin.settings.vlllm.label': 'VLLLM 服务',
  'pages.admin.settings.vlllm.placeholder': '选择 VLLLM 服务',
  'pages.admin.settings.prompt.label': '提示词设置',
  'pages.admin.settings.prompt.placeholder': '请输入系统提示词...',
  'pages.admin.settings.quickReply.label': '快速回复词',
  'pages.admin.settings.quickReply.placeholder': '输入新的快速回复词',
  'pages.admin.settings.quickReply.add': '添加',
  'pages.admin.settings.deleteAudio.label': '删除音频',
  'pages.admin.settings.deleteAudio.enabled': '已开启',
  'pages.admin.settings.deleteAudio.disabled': '已关闭',
  'pages.admin.settings.usePrivateConfig': '使用私有配置',
  'pages.admin.settings.save': '保存配置',
  'pages.admin.settings.saving': '保存中...',
  'pages.admin.settings.reset': '重置',
  'pages.admin.settings.success.saved': '配置保存成功！',
  'pages.admin.settings.error.saveFailed': '保存配置失败，请重试',
  'pages.admin.settings.error.loadFailed': '加载配置失败，请刷新页面重试',

  // Add Device Dialog
  'pages.addDevice.modal.title': '添加设备',
  'pages.addDevice.verificationCode.label': '验证码：',
  'pages.addDevice.verificationCode.placeholder': '请输入设备播报的6位数验证码',
  'pages.addDevice.verificationCode.required': '请输入6位数字验证码',
  'pages.addDevice.verificationCode.error': '请输入6位数字验证码',

  // Provider Modal
  'pages.admin.providerModal.edit.title': '编辑供应商',
  'pages.admin.providerModal.add.title': '添加新供应商',
  'pages.admin.providerModal.name.label': '供应商名称 *',
  'pages.admin.providerModal.name.placeholder': '例如：OpenAI、豆包TTS',
  'pages.admin.providerModal.name.required': '请输入供应商名称',
  'pages.admin.providerModal.type.label': '服务分类 *',
  'pages.admin.providerModal.subType.label': '具体类型 *',
  'pages.admin.providerModal.subType.required': '请选择具体类型',
  'pages.admin.providerModal.config.title': '配置信息',
  'pages.admin.providerModal.api.url.label': 'API地址 *',
  'pages.admin.providerModal.api.url.required': '请输入API地址',
  'pages.admin.providerModal.model.label': '模型 *',
  'pages.admin.providerModal.model.placeholder': '请输入模型名称',
  'pages.admin.providerModal.model.required': '请输入模型名称',
  'pages.admin.providerModal.model.name.label': '模型名称 *',
  'pages.admin.providerModal.model.name.required': '请输入模型名称',
  'pages.admin.providerModal.security.title': '安全设置',
  'pages.admin.providerModal.api.key.label': 'API密钥 *',
  'pages.admin.providerModal.api.key.required': '请输入API密钥',
  'pages.admin.providerModal.temperature.label': '温度 (0-2)',
  'pages.admin.providerModal.temperature.error': '温度值应在0-2之间',
  'pages.admin.providerModal.maxTokens.label': '最大令牌数',
  'pages.admin.providerModal.maxTokens.error': '最大令牌数应在1-32768之间',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': '应用ID *',
  'pages.admin.providerModal.appid.placeholder': '豆包应用ID',
  'pages.admin.providerModal.appid.required': '请输入应用ID',
  'pages.admin.providerModal.accessToken.label': '访问令牌 *',
  'pages.admin.providerModal.accessToken.placeholder': '访问令牌',
  'pages.admin.providerModal.accessToken.required': '请输入访问令牌',
  'pages.admin.providerModal.cluster.label': '集群',
  'pages.admin.providerModal.grpc.host.label': 'gRPC主机 *',
  'pages.admin.providerModal.grpc.host.required': '请输入gRPC主机地址',
  'pages.admin.providerModal.grpc.port.label': 'gRPC端口 *',
  'pages.admin.providerModal.grpc.port.required': '请输入gRPC端口',
  'pages.admin.providerModal.grpc.addr.label': 'gRPC地址（主机:端口）*',
  'pages.admin.providerModal.grpc.addr.required': '请输入gRPC地址（主机:端口）',
  'pages.admin.providerModal.funasr.addr.label': 'funasr 地址（host:port）*',
  'pages.admin.providerModal.funasr.addr.required': '请输入funasr uri（host:port）',
  'pages.admin.providerModal.voice.label': '音色 *',
  'pages.admin.providerModal.voice.required': '请输入语音类型',
  'pages.admin.providerModal.token.label': '令牌 *',
  'pages.admin.providerModal.token.placeholder': '豆包令牌',
  'pages.admin.providerModal.token.required': '请输入令牌',
  'pages.admin.providerModal.websocket.label': 'WebSocket地址 *',
  'pages.admin.providerModal.websocket.required': '请输入WebSocket地址',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'API密钥 *',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'API密钥',
  'pages.admin.providerModal.siliconflow.apiKey.required': '请输入API密钥',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'API地址',
  'pages.admin.providerModal.manage.voices': '管理音色',
  'pages.admin.providerModal.manageVoices': '管理音色',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS 无需额外配置',
  'pages.admin.providerModal.submit.error': '提交失败，请重试',

  // Provider Card
  'pages.admin.providerCard.status.active': '活跃',
  'pages.admin.providerCard.status.inactive': '离线',
  'pages.admin.providerCard.status.error': '错误',
  'pages.admin.providerCard.status.unknown': '未知',
  'pages.admin.providerCard.warning.readonly.test': '只读权限，无法测试供应商',
  'pages.admin.providerCard.warning.readonly.delete': '只读权限，无法删除供应商',
  'pages.admin.providerCard.warning.readonly.edit': '只读权限，无法编辑供应商',
  'pages.admin.providerCard.warning.readonly.toggle': '只读权限，无法切换状态',
  'pages.admin.providerCard.button.disable': '禁用',
  'pages.admin.providerCard.button.enable': '启用',
  'pages.admin.providerCard.button.testing': '测试中...',
  'pages.admin.providerCard.button.test': '测试',
  'pages.admin.providerCard.button.edit': '编辑',
  'pages.admin.providerCard.button.delete': '删除',
  'pages.admin.providerCard.delete.title': '确定要删除此项吗？',
  'pages.admin.providerCard.delete.content': '删除后无法恢复，请确认操作。',
  'pages.admin.providerCard.config.type': '类型',
  'pages.admin.providerCard.config.apiUrl': 'API地址',
  'pages.admin.providerCard.config.model': '模型',
  'pages.admin.providerCard.config.apiKey': 'API密钥',
  'pages.admin.providerCard.config.temperature': '温度',
  'pages.admin.providerCard.config.maxTokens': '最大tokens',
  'pages.admin.providerCard.config.appid': '应用ID',
  'pages.admin.providerCard.config.cluster': '集群',
  'pages.admin.providerCard.config.accessToken': '访问令牌',
  'pages.admin.providerCard.config.grpcHost': 'gRPC主机',
  'pages.admin.providerCard.config.grpcPort': 'gRPC端口',
  'pages.admin.providerCard.config.voice': '音色',
  'pages.admin.providerCard.config.format': '格式',
  'pages.admin.providerCard.config.token': '令牌',
  'pages.admin.providerCard.voices.supported': '支持的语音',
  'pages.admin.providerCard.voices.count': '个',
  'pages.admin.providerCard.test.failed': '测试失败',

  // 白名单
  'pages.admin.whiteList.inputMac': '请输入mac地址',
  'pages.admin.whiteList.batchAdd': '批量添加',
  'pages.admin.whiteList.add': '添加',
  'pages.admin.whiteList.list.title': 'mac地址列表',
  'pages.admin.whiteList.selectCsvTip': '请选择一个csv文件',
  'pages.admin.whiteList.uploadSuccess': '上传成功',
  'pages.admin.whiteList.uploadFailed': '上传失败',
  'pages.admin.whiteList.invalidMac': '请输入有效的mac地址',

  // 运维管理 OpsManage
  'pages.admin.ops.service.title': '服务管理',
  'pages.admin.ops.upload.button': '上传服务文件',
  'pages.admin.ops.upload.success': '服务文件上传成功',
  'pages.admin.ops.upload.error': '服务文件上传失败',
  'pages.admin.ops.restart.button': '重启服务',
  'pages.admin.ops.restart.confirmTitle': '谨慎操作：确认要重启服务吗？',
  'pages.admin.ops.restart.desc': '重启服务将导致当前所有连接断开，服务将短暂不可用。',
  'pages.admin.ops.restart.warn': '此操作仅会关闭当前服务进程，请确保服务器已配置守护进程或自动重启脚本，否则服务将无法自动恢复！',
  'pages.admin.ops.restart.ok': '确认重启',
  'pages.admin.ops.restart.cancel': '取消',
  'pages.admin.ops.restart.success': '服务重启指令已发送',
  'pages.admin.ops.restart.error': '服务重启失败',
  'pages.admin.ops.log.title': '日志浏览与下载',
  'pages.admin.ops.web.upload.button': '上传 web.zip',
  'pages.admin.ops.web.upload.success': 'web.zip 上传成功',
  'pages.admin.ops.web.upload.error': 'web.zip 上传失败',
  'pages.admin.ops.web.upload.onlyzip': '只允许上传 zip 文件',
  'pages.admin.ops.web.update.button': '更新 web 目录',
  'pages.admin.ops.web.update.success': 'web 目录更新指令已发送',
  'pages.admin.ops.web.update.error': 'web 目录更新失败',
  'pages.admin.ops.web.upload.onlywebzip': '只允许上传名为 web.zip 的文件',

  // 录音管理 RecorderManage
  'pages.admin.recorder.title': '设备录音管理',
  'pages.admin.settings.voiceCloneEnable': '启用声音克隆',
  'pages.admin.recorder.inputDeviceId': '请输入设备ID',
  'pages.admin.recorder.inputPlaceholder': '请输入设备ID',
  'pages.admin.recorder.search': '查询',
  'pages.admin.recorder.list.title': '录音列表',
  'pages.admin.recorder.fetchSuccess': '成功获取录音记录',
  'pages.admin.recorder.fetchError': '获取录音列表失败',
  'pages.admin.recorder.empty': '暂无录音数据，请输入设备ID查询',
  'pages.admin.recorder.totalCount': '统计信息',
  'pages.admin.recorder.conversationId': '会话ID',

  'pages.agentSetting.roleTemplate.empty': '暂无模板，请检查 role_template.json',
  'pages.admin.providerModal.save': '保存',
  'pages.admin.providerModal.copyAsNew': '复制为新的供应商',

  // 协约设备
  'pages.contractDevice.cardTitle': '协约设备管理',
  'pages.contractDevice.mac': 'MAC地址',
  'pages.contractDevice.protocolType': '协议类型',
  'pages.contractDevice.status': '状态',
  'pages.contractDevice.expireTime': '到期时间',
  'pages.contractDevice.updateTime': '更新时间',
  'pages.contractDevice.operations': '操作',
  'pages.contractDevice.edit': '编辑',
  'pages.contractDevice.delete': '删除',
  'pages.contractDevice.deleteConfirm': '确认删除',
  'pages.contractDevice.addTitle': '添加协约设备',
  'pages.contractDevice.batchAddTitle': '批量添加',
  'pages.contractDevice.editTitle': '编辑协约设备',
  'pages.contractDevice.listTitle': '协约设备列表',
  'pages.contractDevice.add': '添加',
  'pages.contractDevice.batchAdd': '批量添加',
  'pages.contractDevice.selectCsvTip': '请选择一个csv文件',
  'pages.contractDevice.uploadSuccess': '上传成功',
  'pages.contractDevice.macRequired': '请输入MAC地址',
  'pages.contractDevice.protocolTypeRequired': '请选择协议类型',
  'pages.contractDevice.statusRequired': '请选择状态',
  'pages.contractDevice.expireTimeRequired': '请选择到期时间',

  // 通用按钮和操作
  'pages.common.cancel': '取消',

  // 系统配置相关
  'pages.admin.systemConfig.roleName': '角色名称',
  'pages.admin.systemConfig.roleDesc': '角色描述',
  'pages.admin.systemConfig.enabled': '启用状态',
  'pages.admin.systemConfig.featureName': '功能名称',
  'pages.admin.systemConfig.featureDesc': '功能描述',
  'pages.admin.systemConfig.exitCommand': '退出指令',
  'pages.admin.systemConfig.mcpName': 'MCP名称',
  'pages.admin.systemConfig.newNameOptional': '新名称（可选）',
  'pages.admin.systemConfig.configJson': '配置JSON',
  'pages.admin.systemConfig.useDeviceCode': '使用设备代码',
  'pages.admin.systemConfig.quickReply': '快速回复',
  'pages.admin.systemConfig.shortTermMemory': '短期记忆',
  'pages.admin.systemConfig.saveUserAudio': '保存用户音频文件',
  'pages.admin.systemConfig.enableWhiteList': '启用白名单',
  'pages.admin.systemConfig.enhancedEmotionOutput': '增强情感输出',
  'pages.admin.systemConfig.speakerDetect': '声纹识别',
  'pages.admin.systemConfig.recorderManagerEnable': '启用录音管理',
  'pages.admin.systemConfig.voiceCloneEnable': '启用声音克隆',
  'pages.admin.systemConfig.flattenedChatHistory': '扁平化聊天历史',
  'pages.admin.systemConfig.dialogueHistoryLength': '对话历史长度',
  'pages.admin.systemConfig.userTotalQuota': '用户总额度',
  'pages.admin.systemConfig.dailyClearQuota': '每日清除配额',
  'pages.admin.systemConfig.checkDeviceModeImmediately': '立即检查设备模式',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': '新注册用户默认观察者角色',
  'pages.admin.systemConfig.status': '启用状态',
  'pages.admin.systemConfig.port': '端口',
  'pages.admin.systemConfig.udpShowPort': '显示端口',
  'pages.admin.systemConfig.accessToken': '访问令牌',
  'pages.admin.systemConfig.activateText': '激活文本',
  'pages.admin.systemConfig.logLevel': '日志级别',
  'pages.admin.systemConfig.logDir': '日志目录',
  'pages.admin.systemConfig.logFileName': '日志文件名',

  // 声音克隆相关
  'pages.console.voiceClone.name': '名称',
  'pages.console.voiceClone.provider': '提供商',
  'pages.console.voiceClone.mode': '模式',
  'pages.console.voiceClone.record': '录音',
  'pages.console.voiceClone.upload': '上传',

  // 声纹识别相关
  'pages.console.speakers.name': '名称',
  'pages.console.speakers.mode': '模式',
  'pages.console.speakers.record': '录音',
  'pages.console.speakers.upload': '上传',

  // 设置页面相关
  'pages.console.settings.email': '邮箱',
  'pages.console.settings.oldPassword': '旧密码',
  'pages.console.settings.newPassword': '新密码',
  'pages.console.settings.confirmNewPassword': '确认新密码',

  // VLLM提供商相关
  'pages.providers.vllm.maxPixels': '最大像素数',

  // VAD 配置相关
  'pages.admin.providerModal.vad.enable': '启用本地 VAD',
  'pages.admin.providerModal.vad.type.label': 'VAD 类型',
  'pages.admin.providerModal.vad.addr.label': 'VAD 服务地址 *',
  'pages.admin.providerModal.vad.addr.placeholder': 'localhost:8848',
  'pages.admin.providerModal.vad.addr.required': '请输入VAD服务地址',
};
